<template>
  <div>
    <h1>Сгенерировать рецепт</h1>

    <ul class="nav nav-tabs mt-3 mb-3" id="generateRecipeTab" role="tablist">
      <!-- Single recipe tab -->
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          :class="{ active: activeTab === 'single' }"
          id="single-recipe-tab"
          data-bs-toggle="tab"
          data-bs-target="#single-recipe-pane"
          type="button"
          role="tab"
          aria-controls="single-recipe-pane"
          :aria-selected="activeTab === 'single'"
          @click="activeTab = 'single'"
        >
          Один рецепт
        </button>
      </li>

      <!-- List of recipes tab -->
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          :class="{ active: activeTab === 'list' }"
          id="recipe-list-tab"
          data-bs-toggle="tab"
          data-bs-target="#recipe-list-pane"
          type="button"
          role="tab"
          aria-controls="recipe-list-pane"
          :aria-selected="activeTab === 'list'"
          @click="activeTab = 'list'"
        >
          Список рецептов
        </button>
      </li>

      <!-- Recipe suggestions -->
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          :class="{ active: activeTab === 'suggestions' }"
          id="recipe-suggestions-tab"
          data-bs-toggle="tab"
          data-bs-target="#recipe-suggestions-pane"
          type="button"
          role="tab"
          aria-controls="recipe-suggestions-pane"
          :aria-selected="activeTab === 'suggestions'"
          @click="activeTab = 'suggestions'"
        >
          Рекомендации
        </button>
      </li>
    </ul>

    <div class="tab-content" id="generateRecipeTabContent">
      <!-- Generate a single recipe -->
      <div
        class="tab-pane fade"
        :class="{ 'show active': activeTab === 'single' }"
        id="single-recipe-pane"
        role="tabpanel"
        aria-labelledby="single-recipe-tab"
        tabindex="0"
      >
        <RecipeGenerate v-if="activeTab === 'single'" />
      </div>

      <!-- Generate a list of recipes -->
      <div
        class="tab-pane fade"
        :class="{ 'show active': activeTab === 'list' }"
        id="recipe-list-pane"
        role="tabpanel"
        aria-labelledby="recipe-list-tab"
        tabindex="0"
      >
        <!-- Component for generating a list of recipes -->
        <RecipeGenerateList v-if="activeTab === 'list'" />
      </div>

      <!-- Recipe suggestions -->
      <div
        class="tab-pane fade"
        :class="{ 'show active': activeTab === 'suggestions' }"
        id="recipe-suggestions-pane"
        role="tabpanel"
        aria-labelledby="recipe-suggestions-tab"
        tabindex="0"
      >
        <!-- Component for recipe suggestions -->
        <RecipeSuggestions v-if="activeTab === 'suggestions'" />
      </div>
    </div>
  </div>
</template>

<script>
import RecipeGenerateList from "../RecipeGenerateList.vue";
import RecipeGenerate from "../RecipeGenerate.vue";
import RecipeSuggestions from "../RecipeSuggestions.vue";

export default {
  name: "PageGenerateRecipe",
  components: {
    RecipeGenerateList,
    RecipeGenerate,
    RecipeSuggestions,
  },

  /**
   * Component data:
   * dishName: the name of the dish the user wants to generate a recipe for
   * message: a message to display to the user
   * answers: the response from the server to the recipe generation command
   * result: the generated recipe in JSON format
   * error: an error message if one occurs
   * loading: whether the component is currently loading data
   */
  data() {
    return {
      activeTab: "single", // Default active tab: 'single', 'list', or 'suggestions'
    };
  },
  mounted() {
    // No specific reader needed here if children handle their own teoweb communication
  },
  unmounted() {
    // No specific reader to remove if none was added
  },
  methods: {
    // No specific methods needed here if children are self-contained
  },
};
</script>

<style scoped>
.tab-content {
  /* border: 1px solid #dee2e6; 
  border-top: none;  */
}
</style>
